import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SubmitReviewModal = ({ isOpen, onClose }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    title: '',
    comment: '',
    photos: []
  });

  const categoryOptions = [
    { value: 'pastries', label: 'Pastries & Desserts' },
    { value: 'bread', label: 'Bread & Baked Goods' },
    { value: 'sandwiches', label: 'Sandwiches & Panini' },
    { value: 'cakes', label: 'Custom Cakes' },
    { value: 'catering', label: 'Catering Service' },
    { value: 'service', label: 'Customer Service' },
    { value: 'atmosphere', label: 'Atmosphere' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    console.log('Review submitted:', { rating, ...formData });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-background rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-warm-lg">
        <div className="sticky top-0 bg-background border-b border-border p-6 flex items-center justify-between">
          <h2 className="font-serif text-2xl font-semibold text-foreground">Share Your Experience</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full hover:bg-muted flex items-center justify-center transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-foreground mb-3">
              Overall Rating *
            </label>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5]?.map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  className="transition-transform hover:scale-110"
                >
                  <Icon
                    name="Star"
                    size={32}
                    color={star <= (hoveredRating || rating) ? 'var(--color-warning)' : 'var(--color-muted)'}
                    className={star <= (hoveredRating || rating) ? 'fill-current' : ''}
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              label="Your Name"
              type="text"
              placeholder="John Doe"
              required
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
            />
            <Input
              label="Email Address"
              type="email"
              placeholder="john@example.com"
              required
              value={formData?.email}
              onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
            />
          </div>

          <Select
            label="Category"
            options={categoryOptions}
            value={formData?.category}
            onChange={(value) => setFormData({ ...formData, category: value })}
            placeholder="Select a category"
            required
          />

          <Input
            label="Review Title"
            type="text"
            placeholder="Sum up your experience"
            required
            value={formData?.title}
            onChange={(e) => setFormData({ ...formData, title: e?.target?.value })}
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Your Review *
            </label>
            <textarea
              className="w-full px-4 py-3 rounded-lg border border-input bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-300 min-h-32 resize-y"
              placeholder="Share details of your experience..."
              required
              value={formData?.comment}
              onChange={(e) => setFormData({ ...formData, comment: e?.target?.value })}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Add Photos (Optional)
            </label>
            <div className="border-2 border-dashed border-input rounded-lg p-8 text-center hover:border-primary transition-colors cursor-pointer">
              <Icon name="Upload" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
              <p className="text-sm text-muted-foreground mb-1">Click to upload or drag and drop</p>
              <p className="text-xs text-muted-foreground">PNG, JPG up to 5MB each</p>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} fullWidth>
              Cancel
            </Button>
            <Button type="submit" variant="default" iconName="Send" iconPosition="left" fullWidth>
              Submit Review
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubmitReviewModal;